const nl = {
  common: {
    languages: { en: "English", de: "Deutsch", nl: "Nederlands",  fr: "Français" },
  },

  updateBanner: {
    message: "Er is een nieuwe versie van het portaal beschikbaar.",
    refresh: "Vernieuwen",
    close: "Sluiten",
  },

  session: {
    accessChanged: "Uw toegangsrechten zijn gewijzigd, waardoor sommige pagina's niet meer beschikbaar zijn. Neem contact op met Sibolab als u denkt dat dit een vergissing is.",
  },

  sidebar: {
    portalLabels: {
      admin: "Adminportaal openen",
      therapist: "Therapeutenportaal openen",
      patient: "Klantenportaal openen",
    },
    roleLabels: {
      admin: "Beheerder",
      operator: "Operator",
      therapist: "Therapeut",
      patient: "Klant",
    },
    nav: {
      dashboard: "Dashboard",
      myOrders: "Mijn bestellingen",
      myReports: "Mijn rapporten",
      myPatients: "Mijn patiënten",
      reports: "Rapporten",
    },
    account: {
      signedIn: "Ingelogd",
      settings: "Instellingen",
      logout: "Uitloggen",
    },
  },

  languageSwitcher: {
    promptTitle: "Portaaltaal wijzigen?",
    promptBody: "Moet dit elke keer uw taal zijn wanneer u inlogt, of alleen voor deze sessie?",
    justForNow: "Alleen voor nu",
    saveForNextTime: "Opslaan voor volgende keer",
  },

  twoFactorPrompt: {
    title: "Hoe wilt u inloggen?",
    body: "Voor extra veiligheid kunnen we u bij elke keer inloggen een eenmalige code per e-mail sturen. Als u dit uitschakelt, logt u in met alleen uw e-mailadres en wachtwoord.",
    enable: "E-mailcode behouden (aanbevolen)",
    disable: "Inloggen zonder code",
    changeLater: "U kunt dit altijd wijzigen via Instellingen → Account.",
    error: "Uw keuze kon niet worden opgeslagen. Probeer het opnieuw.",
  },
  settings: {
    dialog: {
      groupLabel: "Instellingen",
      general: "Algemeen",
      account: "Account",
    },
    unsaved: {
      title: "Niet-opgeslagen wijzigingen",
      body: "U heeft wijzigingen die nog niet zijn opgeslagen. Wilt u ze opslaan voordat u verdergaat?",
      save: "Wijzigingen opslaan",
      discard: "Verwerpen",
      keepEditing: "Verder bewerken",
      saveError: "Sommige wijzigingen konden niet worden opgeslagen. Controleer de meldingen op de pagina.",
    },
    general: {
      title: "Profiel",
      fullName: "Volledige naam",
      country: "Land",
      countryPlaceholder: "Selecteer een land",
      language: "Taal",
      languagePlaceholder: "Selecteer een taal",
      lastLogin: "Laatst ingelogd: {{date}}",
      memberSince: "Lid sinds: {{date}}",
      saveChanges: "Wijzigingen opslaan",
      profileUpdated: "Profiel bijgewerkt",
      loadError: "Kan profiel niet laden",
      saveError: "Kan profiel niet bijwerken",
    },
    account: {
      title: "Account",
      changePassword: "Wachtwoord wijzigen",
      previousPasswordPlaceholder: "Huidig wachtwoord",
      newPasswordPlaceholder: "Nieuw wachtwoord",
      confirmNewPasswordPlaceholder: "Nieuw wachtwoord bevestigen",
      cancel: "Annuleren",
      updatePassword: "Wachtwoord bijwerken",
      passwordUpdated: "Wachtwoord succesvol bijgewerkt.",
      errors: {
        fillAllFields: "Vul alle wachtwoordvelden in.",
        mismatch: "Nieuw wachtwoord en bevestiging komen niet overeen.",
        requirements: "Het nieuwe wachtwoord voldoet niet aan de bovenstaande vereisten.",
        generic: "Wachtwoord wijzigen is mislukt",
      },
      twoFactor: {
        title: "Inloggen in twee stappen (e-mailcode)",
        label: "Vraag om een e-mailcode bij het inloggen",
        noteOn: "We sturen u bij elke keer inloggen een eenmalige code per e-mail.",
        noteOff: "U logt in met alleen uw e-mailadres en wachtwoord (minder veilig).",
        save: "Opslaan",
        saved: "Instelling voor inloggen in twee stappen opgeslagen.",
        saveError: "De instelling voor inloggen in twee stappen kon niet worden opgeslagen.",
        loadError: "Uw instelling voor inloggen in twee stappen kon niet worden geladen.",
        confirmTitleOn: "Inloggen in twee stappen inschakelen?",
        confirmBodyOn: "Vanaf uw volgende login sturen we u bij elke keer inloggen een eenmalige code per e-mail.",
        confirmTitleOff: "Inloggen in twee stappen uitschakelen?",
        confirmBodyOff: "Vanaf uw volgende login logt u in met alleen uw e-mailadres en wachtwoord, zonder e-mailcode. Dit is minder veilig.",
        confirm: "Bevestigen",
        cancel: "Annuleren",
      },
      communicationPreferences: {
        title: "Communicatievoorkeuren",
        loadError: "Kan uw communicatievoorkeuren niet laden.",
        savePreferences: "Voorkeuren opslaan",
        saved: "Voorkeuren opgeslagen.",
        saveError: "Kan voorkeuren niet opslaan.",
      },
      therapistApplication: {
        title: "Therapeutaanvraag",
        pending: "Uw aanvraag wordt beoordeeld.",
        revoked: "Uw therapeuttoegang is ingetrokken. Neem contact op met support als u vragen heeft.",
        rejected: "Uw aanvraag is niet goedgekeurd. Neem contact op met support als u vragen heeft.",
        reapply: "Opnieuw aanvragen",
        interested: "Wilt u uw diensten aanbieden via Sibolab? Vraag aan om therapeut te worden.",
        apply: "Aanvragen om therapeut te worden",
        cancel: "Annuleren",
        submit: "Aanvraag indienen",
        errors: {
          fieldsRequired: "Vul uw praktijknaam, plaats en e-mailadres in.",
          docsRequired: "Voeg minstens één licentie- of certificaatdocument toe.",
          generic: "Er is iets misgegaan bij het indienen van uw aanvraag.",
        },
      },
    },
  },

  auth: {
    emailHint: "Het kan even duren voordat de e-mail binnenkomt. Controleer ook uw spam- of ongewenste map.",
    layout: {
      title: "Portal Sibolab",
      subtitleDesktop:
        "Beheer labtests, volg bestellingen, analyseer resultaten en stroomlijn uw laboratoriumworkflow — allemaal op één plek.",
      subtitleMobile: "Beheer labtests, volg bestellingen en bekijk resultaten op één plek.",
      copyright: "© {{year}} Sibolab. Alle rechten voorbehouden.",
    },

    login: {
      title: "Inloggen",
      subtitle: "Voer uw gegevens in om toegang te krijgen tot het portaal",
      emailPlaceholder: "uw@email.com",
      passwordPlaceholder: "Wachtwoord",
      emailRequired: "E-mail is verplicht",
      invalidEmail: "Ongeldig e-mailadres",
      passwordRequired: "Wachtwoord is verplicht",
      forgotPassword: "Wachtwoord vergeten?",
      submit: "Inloggen",
      submitting: "Bezig met inloggen...",
      newToSibolab: "Nieuw bij Sibolab?",
      createAccount: "Account aanmaken",
      errors: {
        shadowAccount: "U heeft nog geen portaalaccount. Maak er een aan met dit e-mailadres.",
        badRequest: "E-mail en wachtwoord zijn verplicht.",
        invalidCredentials: "Onjuist e-mailadres of wachtwoord.",
        inactive: "Dit account is inactief. Neem contact op met een beheerder.",
        tooMany: "Te veel inlogpogingen. Wacht enkele minuten en probeer het opnieuw.",
        generic: "Inloggen is nu niet mogelijk. Controleer uw verbinding en probeer het opnieuw.",
      },
      otp: {
        title: "Verificatiecode invoeren",
        subtitle: "We hebben een 6-cijferige code gestuurd naar {{email}}. Voer deze hieronder in.",
        incorrectCode: "Onjuiste of verlopen code. Controleer de code in uw e-mail en probeer het opnieuw, of vraag een nieuwe aan.",
        verify: "Code verifiëren",
        verifying: "Bezig met verifiëren…",
        notSeeing: "Geen e-mail ontvangen?",
        sendNewCode: "Nieuwe code versturen",
        sending: "Bezig met versturen…",
        wrongEmail: "Verkeerd e-mailadres?",
        changeEmail: "E-mailadres wijzigen",
        resendNotice: "Er is een nieuwe code verstuurd - controleer uw e-mail en voer deze hieronder in.",
        resendError: "Opnieuw versturen is mislukt. Probeer het opnieuw.",
      },
    },

    register: {
      emailStep: {
        title: "Uw account aanmaken",
        subtitle: "Voer uw e-mailadres in om te beginnen.",
        submit: "Doorgaan",
      },
      alreadyHaveAccount: "Heeft u al een account?",
      signIn: "Inloggen",
      errors: {
        tooMany: "Te veel pogingen - wacht enkele minuten en probeer het opnieuw.",
        generic: "Er is iets misgegaan. Probeer het opnieuw.",
      },
      accountExists: {
        title: "Account bestaat al",
        withTherapist:
          "Dit account bestaat al. Log in - u kunt vanuit uw account eventueel een aanvraag doen om therapeut te worden.",
        withoutTherapist: "Dit account bestaat al, log in om verder te gaan.",
        goToLogin: "Naar inloggen",
        wrongEmail: "Verkeerd e-mailadres?",
        tryDifferent: "Probeer een ander e-mailadres",
      },
      otp: {
        title: "Controleer uw e-mail",
        subtitle: "We hebben een 6-cijferige code gestuurd naar {{email}}. Voer deze hieronder in.",
        tooMany: "Te veel pogingen, probeer het later opnieuw.",
        incorrectCode: "Onjuiste of verlopen code. Controleer de code in uw e-mail en probeer het opnieuw, of vraag een nieuwe aan.",
        verify: "Code verifiëren",
        checking: "Bezig met controleren…",
        resent: "Code opnieuw verstuurd - controleer uw e-mail.",
        notSeeing: "Geen e-mail ontvangen?",
        sendNewCode: "Nieuwe code versturen",
        wrongEmail: "Verkeerd e-mailadres?",
        changeEmail: "E-mailadres wijzigen",
        resendError: "De code kon niet opnieuw worden verstuurd. Probeer het opnieuw.",
      },
      completeErrors: {
        expiredCode: "Uw code is verlopen. Verifieer opnieuw.",
        accountExists: "Er bestaat al een account met dit e-mailadres.",
        tooMany: "Te veel pogingen, probeer het later opnieuw.",
        generic: "Er is iets misgegaan. Probeer het opnieuw.",
      },
      therapistApplyFailure:
        "Account aangemaakt - uw therapeutaanvraag kon niet worden verzonden: {{reason}}. U kunt het opnieuw proberen via Accountinstellingen.",
    },

    registerDetails: {
      title: "Uw account afronden",
      subtitle: "Code geverifieerd - nog een paar gegevens en u bent klaar.",
      namePlaceholder: "Naam (optioneel)",
      countryPlaceholder: "Selecteer een land",
      languagePlaceholder: "Selecteer een taal",
      countryRequired: "Selecteer uw land",
      languageRequired: "Selecteer uw taal",
      passwordPlaceholder: "Wachtwoord",
      confirmPasswordPlaceholder: "Wachtwoord bevestigen",
      passwordRequired: "Wachtwoord is verplicht",
      passwordRequirements: "Het wachtwoord voldoet niet aan de bovenstaande vereisten",
      passwordsMismatch: "Wachtwoorden komen niet overeen",
      therapistFieldsRequired: "Vul de naam, stad en het e-mailadres van uw praktijk in om u aan te melden als therapeut",
      therapistDocsRequired: "Voeg minstens één licentie of certificaat toe",
      registerAsTherapist: "Registreren als therapeut",
      registerAsTherapistDesc: "Dien uw praktijkgegevens en licentie in ter beoordeling door een beheerder.",
      submit: "Account aanmaken",
      submitting: "Even geduld…",
    },

    forgotPassword: {
      title: "Wachtwoord opnieuw instellen",
      subtitle: "Voer het e-mailadres van uw account in en wij sturen u een code.",
      submit: "Resetcode versturen",
      rememberedIt: "Weer weten?",
      signIn: "Inloggen",
      errors: {
        tooMany: "Te veel pogingen — wacht enkele minuten en probeer het opnieuw.",
        generic: "Er is iets misgegaan. Probeer het opnieuw.",
      },
      code: {
        title: "Verificatiecode invoeren",
        subtitle: "Als er een account bestaat voor {{email}}, hebben we een 6-cijferige code verstuurd. Voer deze hieronder in.",
        verify: "Code verifiëren",
        checking: "Bezig met controleren…",
        resent: "Code opnieuw verstuurd — controleer uw e-mail.",
        notSeeing: "Geen e-mail ontvangen?",
        tryAgain: "Opnieuw versturen",
        wrongEmail: "Verkeerd e-mailadres?",
        changeEmail: "E-mailadres wijzigen",
        incorrectCode: "Onjuiste of verlopen code. Controleer de code in uw e-mail en probeer het opnieuw, of vraag een nieuwe aan.",
        tooMany: "Te veel pogingen, probeer het later opnieuw.",
        resendError: "De code kon niet opnieuw worden verstuurd. Probeer het opnieuw.",
      },
      done: {
        title: "Wachtwoord bijgewerkt",
        subtitle: "U kunt nu inloggen met uw nieuwe wachtwoord.",
        goToSignIn: "Naar inloggen",
      },
      completeErrors: {
        tooMany: "Te veel pogingen, probeer het later opnieuw.",
        generic: "Er is iets misgegaan. Probeer het opnieuw.",
      },
      needsRegistration: {
        title: "Nog geen wachtwoord ingesteld",
        subtitle: "We hebben een account gevonden voor dit e-mailadres, maar er is nog geen wachtwoord ingesteld. Maak er een aan om toegang te krijgen.",
        cta: "Account aanmaken",
      },
      notFound: {
        title: "Geen account gevonden",
        subtitle: "We konden geen account vinden voor dit e-mailadres.",
        cta: "Account aanmaken",
        tryDifferentEmail: "Ander e-mailadres proberen",
      },
    },

    expiredLink: {
      title: "Deze code is verlopen",
      contactPrefix: "Als het probleem aanhoudt, neem dan contact op met",
      contactLink: "support",
      tryAgain: "Opnieuw proberen",
    },

    setNewPassword: {
      title: "Nieuw wachtwoord instellen",
      subtitle: "Code bevestigd — kies een nieuw wachtwoord voor uw account.",
      newPasswordPlaceholder: "Nieuw wachtwoord",
      confirmPasswordPlaceholder: "Nieuw wachtwoord bevestigen",
      passwordRequired: "Wachtwoord is verplicht",
      passwordRequirements: "Het wachtwoord voldoet niet aan de bovenstaande vereisten",
      passwordsMismatch: "Wachtwoorden komen niet overeen",
      submit: "Wachtwoord bijwerken",
      submitting: "Even geduld…",
    },

    emailStep: {
      emailRequired: "E-mail is verplicht",
      invalidEmail: "Ongeldig e-mailadres",
    },

    passwordStrength: {
      length: "Minstens 8 tekens",
      lowercase: "Eén kleine letter",
      uppercase: "Eén hoofdletter",
      number: "Eén cijfer",
      special: "Eén speciaal teken",
    },

    consent: {
      portalUpdates: "Houd mij op de hoogte van nieuwe portaalfuncties en aankondigingen.",
      marketing: "Stuur mij de IBS/SIBO/IMO-nieuwsbrief.",
    },

    therapistApply: {
      practiceDetails: "Praktijkgegevens",
      reviewNotice: "Een beheerder beoordeelt dit voordat uw therapeutaccount wordt geactiveerd.",
      practiceName: "Praktijknaam",
      practiceNamePlaceholderPortal: "bijv. Kunz Naturheilpraxis",
      practiceCity: "Plaats van de praktijk",
      practiceCityPlaceholderPortal: "bijv. Berlijn",
      practiceEmail: "E-mailadres praktijk",
      practiceEmailHelp: "Dit is het e-mailadres van uw account en kan hier niet worden gewijzigd.",
      licenseCertificates: "Licentie / certificaten",
    },

    documentUpload: {
      clickOrDrag: "Klik om te uploaden of sleep bestanden hierheen",
      hint: "PDF, PNG of JPEG, elk max. 10 MB - {{count}}/{{max}} toegevoegd.",
      tooMany: "U kunt maximaal {{max}} documenten uploaden.",
      invalidType: "{{name}}: alleen PDF-, PNG- en JPEG-bestanden zijn toegestaan.",
      tooLarge: "{{name}}: bestand overschrijdt de limiet van 10 MB.",
    },

    copyButton: {
      copy: "Code kopiëren",
      copied: "Gekopieerd",
    },
  },

  portal: {
    statusTimeline: {
      steps: {
        unprocessed: {
          label: "Bestelling ontvangen",
          bullets: ["Uw bestelling is ontvangen en wordt voorbereid."],
        },
        dispatched: {
          label: "Testkit verzonden",
          bullets: [
            "Uw testkit is onderweg naar u.",
            "U ontvangt de trackinggegevens per e-mail.",
          ],
        },
        received_by_customer: {
          label: "Testkit bezorgd",
          bullets: [
            "Uw testkit is bezorgd.",
            "Voer de test uit en retourneer uw monster met de voorgefrankeerde retourlabel.",
          ],
        },
        returned_to_lab: {
          label: "Monster ontvangen door laboratorium",
          bullets: [
            "We hebben uw geretourneerde monster ontvangen.",
            "Het staat nu in de wachtrij voor analyse.",
          ],
        },
        processing: {
          label: "Analyse in uitvoering",
          bullets: [
            "Uw monster wordt geanalyseerd.",
            "Uw rapport is over 2-3 werkdagen klaar.",
          ],
        },
        analysis_completed: {
          label: "Analyse voltooid",
          bullets: [
            "Uw analyse is voltooid.",
            "Uw rapport wordt binnenkort geleverd.",
          ],
        },
        completed: {
          label: "Rapport gereed",
          bullets: ["Uw rapport is gereed.", "U kunt het hieronder bekijken of downloaden."],
        },
        cancelled: {
          label: "Geannuleerd",
          bullets: ["Deze test is geannuleerd."],
        },
      },
      cancelledReasons: {
        customer: "Geannuleerd door klant",
      },
      tooltip: {
        completed: "{{label}} — Afgerond op {{date}}",
        inProgress: "{{label}} — In behandeling sinds {{date}}",
      },
    },

    statusFilterChips: {
      all: "Alle",
    },

    orderTestActionChips: {
      copied: "Gekopieerd",
      copyFormLink: "Formulierlink kopiëren",
      fillOutForm: "Vul uw formulier in",
      reportProcessing: "Rapport wordt verwerkt",
    },

    viewDownloadButtons: {
      viewReport: "Rapport bekijken",
      download: "Downloaden",
      reportNotFound: "Rapport niet gevonden.",
      fetchLinkError: "Kan de rapportlink niet ophalen.",
    },

    roleSwitchIndicator: {
      viewingAs: "U bekijkt als {{role}}",
    },

    dashboard: {
      recentActivity: {
        title: "Recente activiteit",
        subtitle: "Uw laatste 5 statuswijzigingen",
        empty: "Nog geen recente activiteit.",
      },
      patient: {
        pageTitle: "Dashboard",
        pageSubtitle: "Een overzicht van uw bestellingen en rapporten.",
        summary: {
          totalOrders: "Totaal aantal bestellingen",
          inProgress: "In behandeling",
          completed: "Voltooid",
          reportsAvailable: "Beschikbare rapporten",
        },
        reportsReady: {
          one: "{{count}} rapport klaar om te bekijken",
          other: "{{count}} rapporten klaar om te bekijken",
        },
        goToReports: "Ga naar Mijn Rapporten",
        loadError: "Kan uw dashboard niet laden.",
      },
      therapist: {
        pageTitle: "Dashboard",
        pageSubtitle: "Een overzicht van uw patiënten en tests.",
        summary: {
          totalPatients: "Totaal aantal patiënten",
          totalTests: "Totaal aantal tests",
          completedThisMonth: "Voltooid deze maand",
          inProgress: "In behandeling",
        },
        loadError: "Kan uw dashboard niet laden.",
      },
    },

    orders: {
      patient: {
        title: "Mijn bestellingen",
        subtitle: "Volg uw testkits van bestelling tot rapport.",
        emptyAll: "U heeft nog geen bestellingen.",
        emptyFiltered: "Geen bestellingen komen overeen met dit filter.",
        loadError: "Kan uw bestellingen niet laden.",
      },
      therapist: {
        title: "Bestellingen patiënt",
        subtitle: "Testvoortgang voor deze patiënt.",
        backLabel: "Terug naar patiënten",
        emptyAll: "Nog geen tests voor deze patiënt.",
        emptyFiltered: "Geen tests komen overeen met dit filter.",
        loadError: "Kan bestellingen niet laden.",
        invalidPatient: "Deze patiëntlink is ongeldig.",
      },
    },

    reports: {
      table: {
        order: "Bestelling",
        test: "Test",
        substrate: "Substraat",
        completed: "Voltooid",
        report: "Rapport",
      },
      empty: "Nog geen rapporten.",
      emptyFiltered: "Geen rapporten komen overeen met deze filters.",
      filters: {
        searchPlaceholder: "Zoek op bestelling, test-ID of substraat",
        dateAny: "Alle datums",
        clear: "Wissen",
        done: "Klaar",
      },
      patient: {
        title: "Mijn rapporten",
        subtitle: "Laboratoriumrapporten gekoppeld aan uw account.",
        loadError: "Kan uw rapporten niet laden.",
      },
      therapist: {
        title: "Rapporten",
        subtitle: "Rapporten van alle patiënten die aan u gekoppeld zijn.",
        loadError: "Kan rapporten niet laden.",
      },
    },

    patients: {
      title: "Mijn patiënten",
      subtitle: "Patiënten van wie de tests naar u worden doorgestuurd.",
      searchPlaceholder: "Zoeken op patiëntnaam",
      emptySearch: "Geen patiënten komen overeen met uw zoekopdracht.",
      emptyAll: "Nog geen patiënten.",
      loadError: "Kan uw patiënten niet laden.",
      table: {
        patient: "Patiënt",
        dateOfBirth: "Geboortedatum",
        tests: "Tests",
        latestTest: "Laatste test",
      },
    },

    noAccess: {
      title: "Geen portaaltoegang op dit account",
      subtitle:
        "Uw account is momenteel aan geen enkel portaal toegewezen. Als u denkt dat dit een vergissing is, neem dan contact op met support via info@sibolab.de.",
    },
  },
};

export default nl;
